export enum ConsultancyStatus {
    DNATest,
    FirstConsultancyBooked,
    FirstConsultancyDone,
    CustomisedNutritionPlan,
    SecondConsultancy,
}